<template>
  <div>
    <v-btn depressed color="secondary" v-print="printObj">Yazdır</v-btn>
    <div id="loading" v-show="printLoading"></div>

    <div id="printMe">
      <div style="text-align: center">
        <svg
          width="26mm"
          height="14mm"
          viewBox="0 0 33.826149 20.820894"
          version="1.1"
          id="svg1"
          xml:space="preserve"
          xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
          xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:svg="http://www.w3.org/2000/svg"
        >
          <sodipodi:namedview
            id="namedview1"
            pagecolor="#ffffff"
            bordercolor="#000000"
            borderopacity="0.25"
            inkscape:showpageshadow="2"
            inkscape:pageopacity="0.0"
            inkscape:pagecheckerboard="0"
            inkscape:deskcolor="#d1d1d1"
            inkscape:document-units="mm"
          />
          <defs id="defs1" />
          <g
            inkscape:label="Katman 1"
            inkscape:groupmode="layer"
            id="layer1"
            transform="translate(-83.059771,-113.28031)"
          >
            <path
              style="fill: #000000"
              d="m 83.663777,133.70055 c -0.743146,-0.43284 -0.824973,-1.73563 -0.109014,-1.73563 0.279591,0 0.60646,0.15875 0.726375,0.35278 0.507451,0.82107 1.91338,0.31997 3.147511,-1.12183 1.466126,-1.71284 1.592612,-2.40595 0.439064,-2.40595 -0.452732,0 -0.927605,-0.10446 -1.055273,-0.23212 -0.467823,-0.46783 0.58668,-1.17899 1.748184,-1.17899 1.153774,0 1.241028,-0.10075 2.560271,-2.95625 1.564314,-3.38595 2.472552,-4.45208 3.79272,-4.45208 0.9172,0 0.92765,0.0276 0.70127,1.85208 -0.1264,1.01865 -0.4,3.43958 -0.60801,5.37986 -0.780616,7.28156 1.48891,7.28156 4.12752,0 0.6424,-1.7728 0.902335,-2.11667 1.599935,-2.11667 0.69357,0 0.8214,0.16536 0.76402,0.98831 -0.0407,0.58424 0.35591,1.65816 0.97014,2.62671 0.57147,0.90112 1.03904,1.92482 1.03904,2.27488 0,0.94566 0.43693,0.77137 1.28466,-0.51245 0.51796,-0.78441 0.82818,-1.97595 0.9867,-3.78995 0.28105,-3.21612 0.75796,-4.86014 1.71415,-5.90902 0.7842,-0.86024 2.32002,-1.0499 2.99949,-0.37042 1.06194,1.06193 0.26007,4.3572 -1.8123,7.44764 -1.29903,1.93721 -1.4614,2.3838 -1.2139,3.33892 0.3417,1.31867 0.75183,1.62388 1.82139,1.35544 0.96963,-0.24336 2.68411,-3.22127 2.69188,-4.67557 0.007,-1.26256 0.47029,-2.02815 1.10033,-1.81733 0.35897,0.12011 0.48177,0.96075 0.48177,3.2979 0,2.66465 0.0898,3.15452 0.59696,3.25512 0.37784,0.075 0.802,-0.27809 1.15558,-0.96185 0.30725,-0.59415 0.79268,-1.08027 1.07874,-1.08027 0.66105,0 0.65764,0.47464 -0.0127,1.77095 -0.98802,1.91062 -2.85757,2.31487 -3.99838,0.86457 l -0.70185,-0.89226 -0.96277,0.89226 c -1.62405,1.50512 -4.03659,0.92736 -4.54237,-1.08781 l -0.23547,-0.93819 -0.95136,0.88969 c -2.4929,2.33128 -6.066655,2.74333 -6.066655,0.69948 0,-0.34993 0.41175,-0.45165 1.499315,-0.37041 1.39602,0.10428 1.50681,0.047 1.60834,-0.83129 0.10082,-0.87219 -1.20252,-3.45165 -1.7493,-3.46207 -0.12604,-0.002 -0.515785,0.79271 -0.866105,1.76692 -1.87723,5.22039 -5.657832,5.76226 -6.063612,0.86908 -0.159126,-1.91884 -0.170001,-1.93481 -1.317966,-1.93481 -0.993467,0 -1.28535,0.21813 -2.059498,1.53912 -1.832322,3.12662 -4.386098,4.49139 -6.308812,3.37151 z m 10.006444,-8.27475 c 0.119273,-0.97714 0.328408,-2.12808 0.464745,-2.55764 0.136337,-0.42956 0.102253,-0.78102 -0.07574,-0.78102 -0.257248,0 -1.312173,2.12771 -2.496392,5.03504 -0.06965,0.171 0.327223,0.25901 0.881945,0.19558 0.926262,-0.10593 1.026284,-0.26035 1.225444,-1.89196 z m 14.712889,0.57913 c 1.00881,-1.79494 1.43525,-4.62334 0.69706,-4.62334 -0.62132,0 -1.21403,1.19604 -1.51414,3.05538 -0.12022,0.74489 -0.29184,1.71153 -0.38138,2.14809 -0.25189,1.22824 0.34429,0.93965 1.19846,-0.58013 z m -9.461855,-6.79046 c 1.8e-4,-1.38885 0.40119,-1.71344 2.116835,-1.71344 1.71616,0 2.11675,0.32443 2.11568,1.71344 l -9.9e-4,1.28517 h -2.11584 -2.115845 z m -1.32275,-2.11333 c -1.07849,-1.09267 -0.0971,-3.04943 1.30598,-2.60409 0.503,0.15964 0.72249,0.0728 0.72249,-0.28589 0,-1.06654 2.247275,-1.28965 2.874455,-0.28537 0.23716,0.37976 0.67336,0.58947 1.03136,0.49585 0.95436,-0.24957 1.90832,1.3976 1.38055,2.38374 -0.35309,0.65976 -0.58279,0.72553 -1.70076,0.487 -1.57015,-0.33501 -2.71522,-0.33462 -4.114775,0.001 -0.69108,0.16594 -1.21135,0.0991 -1.4993,-0.19266 z"
              id="path5978"
              inkscape:export-filename="path5978.svg"
              inkscape:export-xdpi="96"
              inkscape:export-ydpi="96"
            />
          </g>
        </svg>
      </div>

      <div
        style="
          background-color: #fff;
          margin-top: 5px;
          padding: 8px;

          border: 1px dotted #ccc;
        "
      >
        <div class="flex">
          <strong> Ad Soyad </strong>
          <p>
            {{ callCenterStore.fullname }}
          </p>
        </div>
        <div class="flex">
          <strong> Telefon</strong>
          <p>
            {{ callCenterStore.phone }}
          </p>
        </div>
        <div class="flex">
          <strong> Fatura/Fiş </strong>
          <p>
            {{ !callCenterStore.data.delivery.needinvoice ? "Evet" : "Hayır" }}
          </p>
        </div>
        <div class="flex">
          <strong> Sipariş Tarihi </strong>

          <p>
            {{ createdatetime | moment("DD MMMM YYYY - HH:mm") }}
          </p>
        </div>
        <div class="flex">
          <strong> Teslimat Tarihi </strong>
          <p>
            {{ callCenterStore.deliveryDate | moment("DD MMMM YYYY") }}
            -
            {{ callCenterStore.deliveryHour }}
          </p>
        </div>

        <div class="flex">
          <strong> Adres </strong>

          <p>
            {{ callCenterStore.data.delivery.address }}
            {{ callCenterStore.data.delivery.city }} /
            {{ callCenterStore.data.delivery.state }}
          </p>
        </div>
        <template v-if="callCenterStore.deliveryNote">
          <div class="flex">
            <strong> Not </strong>

            <p>
              {{ callCenterStore.deliveryNote }}
            </p>
          </div>
        </template>
      </div>

      <v-list
        light
        dense
        style="border: 1px dotted #ccc; padding: 0px 8px; margin-top: 5px"
      >
        <v-list-item
          v-for="(item, index) in callCenterStore.data.products"
          :key="index"
          style="padding: 0px; margin: 0; line-height: 1"
        >
          <v-list-item-content style="padding: 0">
            <v-list-item-title
              style="font-size: 10px; line-height: 1; color: #000"
            >
              {{ item.baslik }}
            </v-list-item-title>
            <v-list-item-subtitle
              style="
                font-size: 10px;
                line-height: 1;
                padding: 0;
                margin: 0;
                color: #000;
              "
            >
              {{ item.quantity }} {{ unitText(item.birim) }} x
              {{ item.satis_fiyati | currency }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action style="font-size: 10px; color: #000"
            >{{ (item.quantity * item.satis_fiyati) | currency }}
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <div class="flex pad">
        <div class="border">
          <strong>Ürün</strong>
          <p>{{ callCenterStore.totalProducts }} Adet</p>
        </div>
        <div class="border">
          <strong>Paket</strong>

          <p>{{ callCenterStore.packageProducts }} Adet</p>
        </div>
        <div class="border">
          <strong>Toplam</strong>
          <p>
            {{ callCenterStore.sumProductsPrice | currency }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import print from "vue-print-nb";
// Store
import { useCallCenterStore } from "@/stores/callCenter";
import store from "@/store";

export default {
  props: ["createdatetime"],
  directives: {
    print,
  },
  data() {
    return {
      printLoading: true,

      printObj: {
        id: "printMe",
        popTitle: "good print",

        beforeOpenCallback(vue) {
          vue.printLoading = true;
        },
        openCallback(vue) {
          vue.printLoading = false;
        },
        closeCallback(vue) {},
      },
    };
  },
  setup() {
    const callCenterStore = useCallCenterStore();

    const unitText = (item) => {
      return store.state.tanimlar.birim.find((el) => el.value === item)?.text || "TANIMSIZ";
    };

    return {
      callCenterStore,
      unitText,
    };
  },
};
</script>

  <style >
#printMe {
  display: none;
}

@media print {
  @page {
    size: 80mm 150mm;
    margin: 3mm 3mm;
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .pad {
    margin-top: 5px;
  }
  .border {
    border: 1px dotted #ccc;
    flex-grow: 1;
    text-align: center;
  }
  strong {
    font-size: 8px;

    margin: 0;
    padding: 0;
  }
  p {
    font-size: 10px;

    margin-bottom: 1px;
  }
  #printMe {
    display: block;
  }
}
</style>